import { render, staticRenderFns } from "./PaymentResultPage.vue?vue&type=template&id=be881f96&scoped=true&"
import script from "./PaymentResultPage.vue?vue&type=script&lang=js&"
export * from "./PaymentResultPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentResultPage.vue?vue&type=style&index=0&id=be881f96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be881f96",
  null
  
)

export default component.exports